import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Patch = async (path, data) => {
  try {
    const result = await axiosInstance.patch(`${baseUrl}/${path}`, data);
    return result;
  } catch (err) {
    throw err;
  }
};

export default Patch;
